/** Shell B — backoffice surfaces, aligned on consumer-web's dark filet vocabulary.
 *
 * Lists are filet rows inside a `border-y` panel — never floating cards. Accent
 * `#00EBBC` marks the active tab and hover affordances only; system chrome stays
 * achromatic (see `@packages/tailwind-config/theme.css`).
 */

export const backofficeListPanel = "border-y border-border/40 bg-card"

export const backofficeListRow =
  "relative flex min-h-[3.75rem] w-full min-w-0 items-center gap-3 px-[14px] py-3 text-left transition-colors hover:bg-muted/40 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-inset focus-visible:ring-ring"

export const backofficeListRowIcon =
  "flex size-9 shrink-0 items-center justify-center rounded-full bg-muted text-muted-foreground"

export const backofficeListRowTitle = "truncate text-sm font-semibold text-foreground"

export const backofficeListRowMeta = "truncate text-xs text-muted-foreground"

export const backofficeIconButton =
  "inline-flex size-8 shrink-0 cursor-pointer items-center justify-center rounded-full text-muted-foreground transition-colors hover:bg-muted hover:text-foreground focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring"

export const backofficeEmptyState = "py-10 text-center text-sm text-muted-foreground"

export const backofficeSearchInput =
  "h-9 rounded-full border border-border/40 bg-card pl-9 font-sans text-xs text-foreground placeholder:text-muted-foreground shadow-none focus-visible:ring-inset focus-visible:ring-offset-0"

/** Form surfaces — stacked filet sections, same register as the lists. */
export const backofficeFormSection = "border-y border-border/40 bg-card px-[14px] py-5"

export const backofficeFormLabel = "mb-2 block text-xs font-medium tracking-wide text-muted-foreground"

export const backofficeFormInput =
  "h-11 rounded-lg border border-border/40 bg-input font-sans text-sm text-foreground placeholder:text-muted-foreground"

/** Radio-style choice row used to pick a headline category. */
export const backofficeChoiceRow =
  "flex w-full cursor-pointer items-start gap-3 border-b border-border/40 px-[14px] py-3.5 text-left transition-colors last:border-b-0 hover:bg-muted/40 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-inset focus-visible:ring-ring"

export const backofficeChoiceRowActive = "bg-muted/60"

export const backofficeBadge =
  "inline-flex h-6 shrink-0 items-center rounded-full border border-border/40 px-2.5 text-[11px] font-medium leading-none text-muted-foreground"

export const backofficeBadgeAccent =
  "inline-flex h-6 shrink-0 items-center rounded-full bg-[#00EBBC] px-2.5 text-[11px] font-semibold leading-none text-black"

/** Floating action menus — lift above list rows with a stronger shell than `bg-card`. */
export const backofficeDropdownContent =
  "z-[130] min-w-[12rem] border border-border/70 bg-background p-1.5 shadow-2xl ring-1 ring-black/25"

export const backofficeDropdownItem =
  "cursor-pointer rounded-md text-foreground transition-colors focus:bg-muted/80 focus:text-foreground data-[highlighted]:bg-muted/80 data-[highlighted]:text-foreground disabled:cursor-not-allowed"

/** Shared with craft test chat input dock and sidebar footer (42px controls + pt-2 / pb-3). */
export const DASHBOARD_CHAT_INPUT_DOCK_HEIGHT = "calc(0.5rem + 42px + 0.75rem)"

export const backofficeSidebarFooterDockButton =
  "h-[calc(0.5rem+42px+0.75rem)] min-h-[calc(0.5rem+42px+0.75rem)] w-full rounded-none"
